import { FormattedMessage } from "react-intl";
import ProductImage from "../ProductImage";
import { InfoValue, ProductContainer, SkeletonDiv, IntegerInputNumber } from "./styles";
import { Flex } from "../../PurchaseSummary/style";
import { PaymentSummaryText } from "../../Checkout/styles";
import { formatCurrency } from "../../Checkout/components/PaymentMethods/utils";

export default function ProductInfo({
  name,
  src,
  desc,
  qtd,
  descMoreLines = true,
  checkout = false,
  onChange,
  onFocus,
  onBlur,
  confirm,
  showQtd,
}) {
  return (
    <ProductContainer descMoreLines={descMoreLines} checkout={checkout}>
      <ProductImage src={src} name={name} />
      <div>
        <p title={name}>{name}</p>
        {!confirm && <span title={desc}>{desc}</span>}
        {confirm && (
          <InfoValue>
            <span title={desc}>{desc}</span>
            <span title={qtd}>x{qtd}</span>
          </InfoValue>
        )}
        {showQtd && (
          <span title={qtd}>
            <FormattedMessage id={"qty"} />
            {parseInt(qtd)}
          </span>
        )}
      </div>
      {checkout && (
        <IntegerInputNumber
          value={qtd}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          min={0}
          precision={0}
          step={1}
          parser={(value) => {
            if (!value) return '';
            return value.replace(/\D/g, '');
          }}
          formatter={(value) => {
            if (!value) return '';
            return value.replace(/\D/g, '');
          }}
        />
      )}
    </ProductContainer>
  );
}

export function ProductInfoSummary({
  name,
  src = null,
  qtd,
  value,
  currency,
  locale,
}) {
  return (
    <Flex justify="space-between">
      <ProductContainer>
        <ProductImage src={src} name={name} />
        <div>
          <p title={name}>{name}</p>
          <span title={qtd}>
            <FormattedMessage id={"qty"} />
            {parseInt(qtd)}
          </span>
        </div>
      </ProductContainer>

      <PaymentSummaryText type="summary" mb="0">
        {formatCurrency({
          value,
          locale,
          currency,
        })}
      </PaymentSummaryText>
    </Flex>
  );
}

export function ProductInfoSkeleton({
  maxW = 450,
  minW = 150,
  threeLines = true,
}) {
  const randomValue = () =>
    Math.floor(Math.random() * (maxW - minW + 1)) + minW + "px";
  return (
    <ProductContainer>
      <ProductImage src={null} name={`name${Math.random()}`} />
      <div>
        <SkeletonDiv width={randomValue()} height="19px" />
        <SkeletonDiv width={randomValue()} height="15px" />
        {threeLines && <SkeletonDiv width="45px" height="15px" />}
      </div>
    </ProductContainer>
  );
}
